var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-item',_vm._b({staticClass:"col-12",class:['range', 'slider'].indexOf(_vm.$attrs.type) !== -1 ?
          ['col-sm-8', 'col-md-6', 'col-lg-4'] :
          ['col-sm-4', 'col-md-3', 'col-lg-2'],attrs:{"value":_vm.value,"md":""},on:{"input":_vm.onChange}},'form-item',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }